<template>
  <div class="content-wrapper">
    <h2 class="page-titles">Fee Report</h2>
    <div class="search-export pt-6">
      <div class="flex items-center">
        <div class="w-1/3 relative">
          <Search
            placeholder="Search by month, year"
            @input="updateSearchTerm"
            :searchOnSubmit="true"
          />
        </div>
        <div class="ml-auto">
          <button
            @click="exportFees"
            :disabled="exportingFees || !loadStatus || !shopifyFees.length"
            :class="{ 'button-loading': exportingFees }"
            class="whitebutton-gemnote button-gemnote-glass--tiny "
          >
            <span>Export </span>
          </button>
        </div>
      </div>
    </div>

    <div class="mt-16">
      <vue-good-table
        :isLoading="!loadStatus"
        :styleClass="
          `vgt-table striped shopify-fees-table ${
            !loadStatus ? 'vgt-table--loading' : ''
          }`
        "
        :columns="columns"
        :rows="shopifyFees"
        mode="remote"
        @on-page-change="handlePageChange"
        :pagination-options="{
          enabled: true,
          perPageDropdownEnabled: false
        }"
      >
        <template slot="loadingContent">
          <div class="">
            <Skeleton width="100%" height="3rem" v-for="i in 5" :key="i" />
          </div>
        </template>

        <template slot="pagination-bottom">
          <Pagination
            :total-items="feesPagination.totalCount || 0"
            :page="serverParams.page - 1"
            :items-per-page="serverParams.perPage"
            @page-change="handlePageChange"
            @perPageChange="handlePerPageChange"
          />
        </template>
      </vue-good-table>
    </div>

    <!-- Modal Here -->
    <ExportModal
      :showFooter="true"
      v-show="isExportModalActive"
      @hideModal="closeModal"
      :showCancelButton="false"
      @confirmAction="closeModal"
    >
      <template slot="header">
        <span>Exporting Fees</span>
      </template>

      <template slot="body">
        <span
          >We are exporting your monthly fee report, we will send a link to
          <strong> {{ user.email }} </strong> when it’s done. Keep an eye on
          your inbox!
        </span>
      </template>
    </ExportModal>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'
import { mapState } from 'vuex'
import Util from '../../mixins/Util'
import Skeleton from '../Universal/Skeleton'
import Pagination from '@/components/Universal/Pagination'
import Search from '@/components/Universal/Search'
import ExportModal from '@/components/Universal/ExportModal'
import { progressStatus } from '@/helpers'

export default {
  name: 'EcommerceOrders',
  mixins: [Util],
  components: {
    ExportModal,
    VueGoodTable,
    Skeleton,
    Pagination,
    Search
  },
  data() {
    return {
      serverParams: {
        page: 1,
        perPage: 10,
        seachTerm: ''
      },
      columns: [
        {
          label: 'Month',
          field: 'month'
        },
        {
          label: 'No.of orders',
          field: 'total_orders'
        },
        {
          label: 'Fulfillment  fees',
          field: 'total_fulfillment_fees',
          formatFn: this.formatCurrency
        },
        {
          label: 'Shipping fees',
          field: 'total_shipping_fees',
          formatFn: this.formatCurrency,
          width: '200px'
        }
      ]
    }
  },
  computed: {
    ...mapState({
      fees: state => state.shopify.fees,
      loadingFees: state => state.shopify.loadShopifyFees,
      exportingFees: state => state.ecommerce.exportingOrder,
      isExportModalActive: state => state.modal.isExportModalActive,
      user: state => state.profile.user,
      searchTerm: state => state.globalTracking.searchTerm
    }),

    feesPagination() {
      return this.fees.meta || {}
    },
    shopifyFees() {
      return this.fees.data
    },
    loadStatus() {
      return progressStatus(this.loadingFees)
    }
  },
  created() {
    this.$store.dispatch('globalTracking/changeSearchTerm', '')
    this.getMonthlyFees()
  },
  methods: {
    exportFees() {
      this.$store.dispatch('shopify/exportShopifyFees')
    },
    handlePageChange(page) {
      this.serverParams.page = page
      this.getMonthlyFees(this.serverParams.page + 1)
    },
    handlePerPageChange(e) {
      this.serverParams.perPage = e
      this.getNextChuckOfOrders()
    },
    getMonthlyFees(page = 1) {
      this.$store.dispatch('shopify/getMonthlyFees', {
        page,
        perPage: this.serverParams.perPage,
        search: this.serverParams.seachTerm
      })
    },

    getNextChuckOfOrders() {
      this.$store.dispatch('ecommerce/getOrderList', {
        page: this.serverParams.page + 1,
        perPage: this.serverParams.perPage,
        search: this.serverParams.seachTerm
      })
    },
    updateSearchTerm(query) {
      this.serverParams.seachTerm = query
    },

    closeModal() {
      this.$store.dispatch('modal/setExportModal', false)
    }
  },
  watch: {
    async searchTerm(newVal) {
      this.serverParams.seachTerm = newVal
      await this.getMonthlyFees()
    }
  }
}
</script>

<style lang="scss" scoped>
.button-gemnote-glass--tiny {
  width: auto;
  height: 2.4rem;
  padding: 0 1.5rem !important;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
}

input {
  &::placeholder {
    color: #6c7a7b;
    font-size: 0.875rem;
  }
}

.border-2 {
  border: 1px solid #232220;
}

.border-l-2 {
  border-left: 1px solid #232220;
}

.value {
  color: #24292c;
  font-size: 1.375rem;
}
</style>
